import React from 'react';

export function KnowledgebaseIcon({ size = 48 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M43 18.3L24 29.7L5 18.3L24 6.89999L43 18.3Z" stroke="#FF6D34" strokeWidth="2" strokeMiterlimit="10" />
      <path d="M37.3008 21.76V31.6" stroke="#FF6D34" strokeWidth="2" strokeMiterlimit="10" />
      <path
        d="M37.2992 31.6V33.5C37.2992 37.7 31.2992 41.1 23.9992 41.1C16.6992 41.1 10.6992 37.7 10.6992 33.5V21.76"
        stroke="#FF6D34"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path d="M24 18.3L31.6 25.9" stroke="#FF6D34" strokeWidth="2" strokeMiterlimit="10" />
      <path d="M31.5996 33.5V25.9" stroke="#FF6D34" strokeWidth="2" strokeMiterlimit="10" />
    </svg>
  );
}
